"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EContentType = exports.EBatchType = void 0;
var EBatchType;
(function (EBatchType) {
    EBatchType[EBatchType["QUESTION"] = 0] = "QUESTION";
    EBatchType[EBatchType["STATION"] = 1] = "STATION";
    EBatchType[EBatchType["CHAPTER"] = 2] = "CHAPTER";
    EBatchType[EBatchType["VIDEO"] = 3] = "VIDEO";
    EBatchType[EBatchType["MOCK_TEST"] = 4] = "MOCK_TEST";
    EBatchType[EBatchType["CONCEPT"] = 5] = "CONCEPT";
    EBatchType[EBatchType["TOPIC"] = 6] = "TOPIC";
    EBatchType[EBatchType["CARD"] = 7] = "CARD";
})(EBatchType = exports.EBatchType || (exports.EBatchType = {}));
var EContentType;
(function (EContentType) {
    EContentType[EContentType["MARKDOWN"] = 0] = "MARKDOWN";
    EContentType[EContentType["CSV"] = 1] = "CSV";
})(EContentType = exports.EContentType || (exports.EContentType = {}));
